import $ from 'jquery';

//DOWNLOAD (COOKIE)
var setCookie = function (name, value, expiracy) {
    var exdate = new Date();
    exdate.setTime(exdate.getTime() + expiracy * 1000);
    var c_value = escape(value) + ((expiracy == null) ? "" : "; expires=" + exdate.toUTCString());
    document.cookie = name + "=" + c_value + '; path=/';
};

var getCookie = function (name) {
    var i, x, y, ARRcookies = document.cookie.split(";");
    for (i = 0; i < ARRcookies.length; i++) {
        x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
        y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
        x = x.replace(/^\s+|\s+$/g, "");
        if (x == name) {
            return y ? decodeURI(unescape(y.replace(/\+/g, ' '))) : y; //;//unescape(decodeURI(y));
        }
    }
};

var downloadTimeout;
var checkDownloadCookie = function ($target) {
    if (getCookie("downloadStarted") === "1") {
        $target.text($target.data('original-text'));
        $target.removeClass('disabled');
        $target.prop('disabled', false);
        setCookie("downloadStarted", "false", -1);
        if ($('#esgModal').is(':visible')) {
            var url = $('.js-get-esgreport').attr('href');
            $('.js-get-esgreport').attr('href', url.split('?')[0]);
            $('#esgModal').modal('toggle');
        }
    } else {
        downloadTimeout = setTimeout(function () {
            checkDownloadCookie($target)
        }, 500);
    }
};

export function AddLoadingAnimation() {
    $(".btn-animate").on("click", function (ev) {
        var $this = $(this);
        
        //ga props
        window.dataLayer.push({
            event: "downloadAsset",
            download:{
                assetInfo: {
                    productName: $this.data('product'),
                    companyName: $this.data('companyname'),
                    companyOrg: $this.data('companyorgno')
                }
            }
        });
        $this.text('');
        $this.append('<i class="fas fa-spinner fa-spin"></i>');
        $this.addClass('disabled'); 
        $this.prop('disabled', true);
        setTimeout(function () {
            checkDownloadCookie($this);
        }, 500);
    });
}

$(document).ready(function () {

    var $initorder = $(".initorder");
    var $initorderForm = $(".initorder__form");
    var $initorderCol = $(".initorder-col");
    var $initorderInput = $('.initorder__input');
    var $initorderBtn = $('.initorder__btn');
    
    var $searchCompanyForm = $('.search-company-form');
    
    //INITORDER
    $initorderBtn.attr('disabled', true);

    if ($initorderInput.val()) {
        var $wrapper = $initorderInput.closest('.block');
        var $btn = $wrapper.find('.initorder__btn');
        $btn.attr('disabled', false);
    }

    $initorderInput.keyup(function () {
        var $this = $(this);
        var $wrapper = $this.closest($initorderForm);
        $wrapper
            .find('.initorder__btn')
            .attr('disabled', $this.val().trim().length != 0);

        if ($this.val().trim().length != 0) {
            $wrapper.find('.initorder__btn').attr('disabled', false);
        } else {
            $wrapper.find('.initorder__btn').attr('disabled', true);
        }
    });
    
    if ($searchCompanyForm.length) {
        $initorderInput.keyup(function () {
            var $this = $(this);
            var $wrapper = $this.closest($searchCompanyForm);
            $wrapper
                .find('.initorder__btn')
                .attr('disabled', $this.val().trim().length != 0);

            if ($this.val().trim().length != 0) {
                $wrapper.find('.initorder__btn').attr('disabled', false);
            } else {
                $wrapper.find('.initorder__btn').attr('disabled', true);
            }
        });
    }

    //Show cta on scroll
    if ($initorder.length) {
        var b2bDidScroll;
        var b2bLastScrollTop = 0;
        var b2bDelta = 5;
        var b2bForm = $initorder.outerHeight();
        if (!$initorderCol.length)
            return;

        var b2bFormTop = $initorderCol.offset().top;
        var b2bScrollHeight = b2bForm + b2bFormTop;

        $(window).scroll(function (event) {
            b2bDidScroll = true;
        });

        setInterval(function () {
            if (b2bDidScroll) {
                b2bHasScrolled();
                b2bDidScroll = false;
            }
        },
            250);

    }

    function b2bHasScrolled() {
        var b2bSt = $(this).scrollTop();
        if (Math.abs(b2bLastScrollTop - b2bSt) <= b2bDelta)
            return;
        if (b2bSt < b2bScrollHeight) {
            $(".dockedcta").removeClass("dockedcta--active");
        } else {
            if (b2bSt > b2bScrollHeight) {
                $(".dockedcta").addClass("dockedcta--active");
            }
        }
        b2bLastScrollTop = b2bSt;
    }

    //Dockedcta__btn
    $(document).on("click", ".dockedcta__btn", function (event) {
            event.preventDefault();
            $('html, body').stop().animate({
                scrollTop: b2bFormTop - 120
            },
                1000);
        });

    //Userdocuments filter
    $(".documentfilter__layer").hide();

    $(document).on("click", ".documentfilter__trigger", function (event) {
            event.preventDefault();
            if ($(".documentfilter__layer").hasClass("active")) {
                $(".documentfilter__layer").removeClass("active").hide();
            } else {
                $(".documentfilter__layer").addClass("active").show();
            }
        });

    $(document).mouseup(function (e) {
        var filterlayer = $(".documentfilter__layer");
        if (!filterlayer.is(e.target) && filterlayer.has(e.target).length === 0) {
            filterlayer.removeClass("active").hide();
        }
    });

    //Filter demo
    $(".documentfilter .checkbox-input").change(function () { 
        if ($(".documentfilter .checkbox-input").is(":checked")) {
            $("#clearfilter__trigger").removeClass("hidden");
            $("#applyfilter__trigger").removeClass("disabled");
        } else {
            $("#applyfilter__trigger").addClass("disabled");
            $("#clearfilter__trigger").addClass("hidden");
        }
    });

    $(document).on("click",
        "#clearfilter__trigger",
        function (event) {
            event.preventDefault();
            $(".documentfilter input:checked").each(function () {
                $(this).prop('checked', false);
            });
        });

    var $form = $(this);
    var $btn = $form.find('#approve-btn');
    $btn.removeClass('disabled');

    var $downloadStatus = $('input[name="downloadStatus"]').val();
    if ($downloadStatus === "failed") {        
        $('#fileDownloadFailed').modal('show');
    }
    var $esgDownloadStatus = $('input[name="downloadEsgStatus"]').val();

    if ($esgDownloadStatus === "failed409") {
        $('#esgFileDownloadFailed409').modal('show');
    }
    if ($esgDownloadStatus === "failed401") {
        $('#esgFileDownloadFailed401').modal('show');
    }
    if ($esgDownloadStatus === "failed") {
        $('#esgFileDownloadFailed').modal('show');
    }
    $(".modal-download-failed").on('hidden.bs.modal', function () {
        var uri = window.location.href.toString();
        if (uri.indexOf("?") > 0) {
            var clean_uri = uri.substring(0, uri.indexOf("?"));
            window.history.replaceState({}, document.title, clean_uri);
        }
    });
        
    document.querySelector('#approve-btn').addEventListener('click', function (event) {
            var btn = event.target;
            btn.classList.add('disabled');
    });
    
});  